import type {
  AuthPort,
} from '../core/types';
import { createAuthAccountService } from './createAuthAccountService';
import { createAuthCredentialsService } from './createAuthCredentialsService';
import { createVerificationRecoveryService } from './createVerificationRecoveryService';

export function createAuthUseCases(authPort: AuthPort) {
  return {
    ...createAuthCredentialsService(authPort),
    ...createVerificationRecoveryService(authPort),
    ...createAuthAccountService(authPort),
  };
}
